import userManager from '../lib/userManager'

const SilentRenewCallback = () => {
    userManager.signinSilentCallback()
    return null
}

export default SilentRenewCallback
